import React from "react";
import Sidebar from "../../layout/Sidebar";
import { X } from "lucide-react";

export default function MobileDrawer({ isOpen, onClose, activeTab, setTab }) {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.backdrop} onClick={onClose} />
      <div style={styles.drawer}>
        <div style={styles.header}>
          <span style={styles.menuLabel}>Menu</span>
          <button onClick={onClose} style={styles.closeBtn}>
            <X size={24} color="#64748b" />
          </button>
        </div>

        <div style={styles.sidebarWrapper} className="mobile-sidebar-container">
          {/* This Sidebar component will now trigger the new cases 
              in MobileDashboard when an item is clicked.
          */}
          <Sidebar 
            tab={activeTab} 
            setTab={(id) => {
              setTab(id);
              onClose(); 
            }} 
          />
        </div>
      </div>

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .mobile-sidebar-container > div {
          height: 100% !important;
          width: 100% !important;
          border-right: none !important;
          background: transparent !important;
        }
        .mobile-sidebar-container button[class*="collapse"] {
          display: none !important;
        }
        .mobile-sidebar-container {
          overflow-x: hidden !important;
          width: 100%;
        }
      `}</style>
    </div>
  );
}

const styles = {
  overlay: { position: "fixed", inset: 0, zIndex: 10000, display: "flex", justifyContent: "flex-end", overflow: "hidden" },
  backdrop: { position: "absolute", inset: 0, background: "rgba(0, 0, 0, 0.7)", backdropFilter: "blur(4px)" },
  drawer: { position: "relative", width: "280px", height: "100dvh", background: "#0f172a", display: "flex", flexDirection: "column", animation: "slideInRight 0.3s ease-out", boxShadow: "-10px 0 30px rgba(0,0,0,0.5)" },
  header: { padding: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.05)" },
  menuLabel: { color: "#fff", fontSize: "18px", fontWeight: "700" },
  closeBtn: { background: "none", border: "none" },
  sidebarWrapper: { flex: 1, overflowY: "auto" }
};